
import timer_icon from "../assets/images/timer_icon.png";
import ai_icon from "../assets/images/ai_icon.png";
import bussiness_analytic_icon from "../assets/images/bussiness_analytic_process.png";

export const upperSectionCardsData = [
  {
    id: 1,
    title: "Real Time Analysis",
    description: "Stay updated with real-time analysis",
    icon: timer_icon,
  },
  {
    id: 2,
    title: "Interactive Dashboards",
    description:
      "Analyze data with customizable reports to uncover insights and optimize performance across your operations.",
    icon: bussiness_analytic_icon,
  },
  {
    id: 3,
    title: "AI Integrated",
    description:
      "Analyze data with customizable reports to uncover insights and optimize performance across your operations.",
    icon: ai_icon,
  },
];
